export default {
  inboundChatIndicator: '{{name}} is typing',
  inboundAriaDefinitionText: 'from {{name}}:',
  outboundAriaDefinitionText: 'from me:',
};
